/**
 * @generated SignedSource<<c6cb7131b274384997bf093c3c83e9ec>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ConcreteRequest } from 'relay-runtime';
export type rbacCheckQuery$variables = {
  isForGoals: boolean;
  isForProjects: boolean;
  workspaceUuid: string;
};
export type rbacCheckQuery$data = {
  readonly workspaceByUuid: {
    readonly aiPermittedForGoals?: boolean;
    readonly aiPermittedForProjects?: boolean;
  } | null;
};
export type rbacCheckQuery = {
  response: rbacCheckQuery$data;
  variables: rbacCheckQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isForGoals"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isForProjects"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "workspaceUuid"
},
v3 = [
  {
    "kind": "Variable",
    "name": "uuid",
    "variableName": "workspaceUuid"
  }
],
v4 = {
  "condition": "isForGoals",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "aiPermittedForGoals"
    }
  ]
},
v5 = {
  "condition": "isForProjects",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "aiPermittedForProjects"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "rbacCheckQuery",
    "selections": [
      {
        "args": (v3/*: any*/),
        "concreteType": "Workspace",
        "kind": "LinkedField",
        "name": "workspaceByUuid",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/)
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "rbacCheckQuery",
    "selections": [
      {
        "args": (v3/*: any*/),
        "concreteType": "Workspace",
        "kind": "LinkedField",
        "name": "workspaceByUuid",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "kind": "ScalarField",
            "name": "id"
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "9808d789a70f245361d40a1016c1c95b",
    "id": null,
    "metadata": {},
    "name": "rbacCheckQuery",
    "operationKind": "query",
    "text": "query rbacCheckQuery(\n  $workspaceUuid: UUID!\n  $isForGoals: Boolean!\n  $isForProjects: Boolean!\n) {\n  workspaceByUuid(uuid: $workspaceUuid) {\n    aiPermittedForGoals @include(if: $isForGoals)\n    aiPermittedForProjects @include(if: $isForProjects)\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "396c5707b501860f35af87768bbae7d1";

export default node;
